import type { AuditIndexItem } from "@/types";
import { auditStatusIconClasses, auditStatusIconLabel } from "./auditIndexHelpers";

export default function AuditStatusIcon({ audit }: { audit: AuditIndexItem }) {
  return (
    <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${auditStatusIconClasses(audit)}`}>
      <span className="text-xl font-semibold" aria-hidden="true">
        {auditStatusIconLabel(audit)}
      </span>
    </div>
  );
}
